const archive = document.querySelector('.post-type-archive');

if(archive) {
  const moreBtn = archive.querySelector('.display-all-news');
  if(moreBtn) {
    moreBtn.addEventListener('click', function(e) {
      archive.querySelectorAll('.year-wrapper').forEach(function(year, index) {
        year.classList.add('show');
      });
      moreBtn.classList.add('hide');
    });
  }
}